import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const searchAreaSelector = (state: RootState) => state.searchArea;

export const getIsCollapse = createSelector(
  searchAreaSelector,
  (state) => state.isCollapse,
);
